import { render, staticRenderFns } from "./shipmentComponentDetail.vue?vue&type=template&id=76c0e6a2&scoped=true"
import script from "./shipmentComponentDetail.vue?vue&type=script&lang=js"
export * from "./shipmentComponentDetail.vue?vue&type=script&lang=js"
import style0 from "./shipmentComponentDetail.vue?vue&type=style&index=0&id=76c0e6a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c0e6a2",
  null
  
)

export default component.exports